module.exports = __webpack_public_path__ + "img/poster.bfad2d12.jpg";